import { render, staticRenderFns } from "./add-minichallenge.vue?vue&type=template&id=5c69d430&scoped=true"
import script from "./add-minichallenge.vue?vue&type=script&lang=js"
export * from "./add-minichallenge.vue?vue&type=script&lang=js"
import style0 from "./add-minichallenge.vue?vue&type=style&index=0&id=5c69d430&prod&lang=css"
import style1 from "./add-minichallenge.vue?vue&type=style&index=1&id=5c69d430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69d430",
  null
  
)

export default component.exports